import { EntityRequestBiztrip } from "../../entity/EntityRequestBiztrip";

export class DtoRequestBiztripsDeleteRes extends EntityRequestBiztrip {
  public message: string | null = null;
}
